var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\n\t\tEmail icon\n\t") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,30) scale(0.0100000,-0.0100000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1720 l0 -970 1400 0 1400 0 0 970 0 970 -1400 0 -1400 0 0 -970z m2314 741 c-5 -5 -213 -144 -461 -310 l-453 -301 -452 301 c-249 166 -457 305 -462 310 -6 5 382 9 914 9 532 0 920 -4 914 -9z m-1736 -322 c191 -127 351 -235 355 -239 5 -4 -133 -105 -305 -226 -172 -120 -334 -233 -360 -252 l-48 -34 0 491 c0 270 2 491 5 491 3 0 162 -104 353 -231z m2002 -260 l0 -491 -32 24 c-18 13 -180 127 -361 253 -180 125 -325 230 -322 233 12 12 701 471 708 471 4 1 7 -220 7 -490z m-1315 -199 c66 -44 126 -80 134 -80 8 0 70 36 138 80 68 44 128 80 133 80 5 0 211 -141 457 -313 l448 -313 3 -82 3 -82 -1181 0 -1181 0 3 82 3 82 445 312 c245 172 452 313 460 313 8 1 69 -35 135 -79z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.9f54811257aeaa5e05b566001b6ca3a3.svg";
export { ForwardRef as ReactComponent };